import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import LanguageSelector from '@/components/LanguageSelector';
import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { isMobile } = usePlatform();

  return (
    <div className={styles.viewBox}>
      <header className={styles.topbar}>
        <span className={styles.wordmark}>Aletyn Account</span>
        <LanguageSelector />
      </header>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
        </main>
      </div>
      <footer className={styles.footer}>
        <span>Aletyn Technology Limited</span>
      </footer>
    </div>
  );
};

export default AppLayout;
